var _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6665 22C58.6665 30.1002 52.1 36.6666 43.9998 36.6666C35.8997 36.6666 29.3332 30.1002 29.3332 22C29.3332 13.8998 35.8997 7.33331 43.9998 7.33331C52.1 7.33331 58.6665 13.8998 58.6665 22ZM51.3332 22C51.3332 26.0501 48.0499 29.3333 43.9998 29.3333C39.9497 29.3333 36.6665 26.0501 36.6665 22C36.6665 17.9499 39.9497 14.6666 43.9998 14.6666C48.0499 14.6666 51.3332 17.9499 51.3332 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5252 41.4774C30.8448 40.131 27.58 39.7346 25.2724 41.6508C18.7927 47.0314 14.6665 55.1483 14.6665 64.2289V74.5639C14.6665 77.9344 17.3988 80.6667 20.7693 80.6667H67.2304C70.6009 80.6667 73.3332 77.9344 73.3332 74.5639V64.2289C73.3332 55.1482 69.207 47.0313 62.7272 41.6507C60.4195 39.7345 57.1548 40.131 54.4744 41.4773C51.2856 43.079 47.7379 43.972 43.9997 43.972C40.2615 43.972 36.7139 43.079 33.5252 41.4774ZM21.9998 64.2289C21.9998 57.661 24.8698 51.7695 29.4483 47.7283L29.4958 47.7408C29.7086 47.799 29.9616 47.8939 30.2336 48.0305C34.4047 50.1256 39.0757 51.3053 43.9997 51.3053C48.9238 51.3053 53.5948 50.1255 57.766 48.0304C58.038 47.8938 58.291 47.7989 58.5038 47.7408L58.5513 47.7282C63.1299 51.7694 65.9998 57.661 65.9998 64.2289V73.3334H21.9998V64.2289Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.6667,
    cy: 11,
    rx: 3.66667,
    ry: 3.66667
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotification);
export default __webpack_public_path__ + "static/media/profile-notification.b9f23008f7cb11697b45d77641ae5373.svg";
export { ForwardRef as ReactComponent };